// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/reading-upper-air-contours-and-winds.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/reading-upper-air-contours-and-winds/reading-upper-air-contours-and-winds.js';

mount([g0]);
